// extracted by mini-css-extract-plugin
module.exports = {"title":"categories-picker_title__a9fhM"};